import styled from 'styled-components';
import { theme } from '../../styles/constants';

// ------ Wrapper ------
export const TableWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #f3f4f6;
  background-color: #fff;
  border-radius: 1.6rem;
  min-height: ${props => props.$fullHeight && '64.2rem'};
`;

// ------ Table ------
export const StyledTable = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  position: relative;
`;

// ------ Header ------
export const TableHeader = styled.thead`
  height: 4rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f4f6;
  background-color: #f3f4f6;
  border-top-right-radius: 1.6rem;
  border-top-left-radius: 1.6rem;
`;

export const TableHeaderRow = styled.tr`
  display: flex;
  flex: 1;
`;

export const TableHeaderItem = styled.th`
  font-size: 1.4rem;
  font-weight: 300;
  display: flex;
  flex: ${props => (props.$isAction ? 'none' : 1)};
  width: ${props => (props.$isAction ? (props.$actionWidth ? `${props.$actionWidth}rem` : '4rem') : 'auto')};
  align-items: center;
  cursor: ${props => (props.$sortable ? 'pointer' : 'default')};
  color: ${props => (props.$sorted ? '#0B3A5F' : '#040B1050')};
  min-width: 2rem;
  padding-left: 1rem;
  max-width: ${props => (props.$fixedWidth ? `${props.$fixedWidth}rem` : 'none')};

  &:first-of-type {
    padding-left: 1.6rem;
  }
`;

export const ExpandableTableHeaderItem = styled.th`
  width: 5.2rem;
`;

// ------ Body ------
export const TableBody = styled.tbody`
  display: flex;
  flex-direction: column;
  height: 56rem;
  overflow: auto;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 5.6rem;
    background: ${({ $showFade }) => $showFade && 'linear-gradient(to top, #fff 0%, transparent 100%)'};
    pointer-events: none;
    z-index: 1;
  }
`;

export const TableBodyRow = styled.tr`
  display: flex;
  min-height: 5.6rem;
  border-bottom: ${props => (props.$expandedRow ? 'none' : '1px solid #f2f2f2')};
  cursor: ${props => (props.expandable || props.$pointer ? 'pointer' : 'default')};
`;

export const TableBodyItem = styled.td`
  font-size: 1.5rem;
  font-weight: 300;
  color: ${theme.colors.textColor};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: ${props => props.$textCenter && 'center'};
  padding-left: 1rem;
  max-width: ${props => (props.$fixedWidth ? `${props.$fixedWidth}rem` : 'none')};

  &:first-of-type {
    padding-left: 1.6rem;
  }
`;

export const TableItemImage = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  margin-right: 1.2rem;
`;

export const ActionTableBodyItem = styled(TableBodyItem)`
  width: 4rem;
  flex: none;
`;

// ------ Footer ------
export const TableFooter = styled.div`
  height: 4rem;
  display: flex;
  justify-content: ${({ $hasPerPageSelect }) => ($hasPerPageSelect ? 'space-between' : 'flex-end')};
  align-items: center;
  padding: 1.6rem 2.4rem;
  font-size: 1.2rem;
  line-height: 2.4rem;
  font-weight: 500;
`;

// ------ Other ------
export const CenteredContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const NoDataText = styled.p`
  color: #170c2f;
  font-size: 1.6rem;
`;
